export default "__VITE_ASSET__$81EB2Bt__"